import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { device } from 'utils';
import MoreProjectCard from './MoreProjectCard';
import LikeButton from '../Like/LikeButton';

function MoreProjects({ randomProjects, isTicketable = false, title }) {
  const sectionTitle =
    title ||
    (isTicketable
      ? 'Crowdfunding Projekte Deiner Community'
      : 'Weitere Projekte');

  if (!randomProjects?.length) {
    return null;
  }

  return (
    <RelatedProjectsWrapper>
      <Title>{sectionTitle}</Title>
      <CardsWrapper>
        {randomProjects.map((project, index) => (
          <CardItem key={project?.id || project?._id || index}>
            <LikeButton absoluteRight={true} project={project} />
            <MoreProjectCard project={project} />
          </CardItem>
        ))}
      </CardsWrapper>
    </RelatedProjectsWrapper>
  );
}

MoreProjects.propTypes = {
  randomProjects: PropTypes.array.isRequired,
  isTicketable: PropTypes.bool,
  title: PropTypes.string,
};

const RelatedProjectsWrapper = styled.section`
  margin-top: 30px;

  @media ${device.allMobile} {
    padding: 10px;
  }
`;

const Title = styled.h2`
  font-size: 24px;
  color: #181d27;
  font-weight: 600;
  line-height: 32px;
`;

const Description = styled.h4`
  font-size: 16px;
  color: #535862;
  font-weight: 400;
  line-height: 24px;
`;

const CardsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  width: 100%;
  margin-top: 16px;
  gap: 16px;

  @media (max-width: 980px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media ${device.allMobile} {
    display: flex;
    width: 100%;
    margin: 24px auto auto;
    justify-content: flex-start;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0 10px 12px;
    scroll-snap-type: x mandatory;
    scroll-padding: 0 24px;
    -webkit-overflow-scrolling: touch;

    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

const CardItem = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 24px;
  position: relative;

  & > article {
    max-width: 100%;
    margin: 0 auto;
  }

  @media ${device.allMobile} {
    width: 85%;
    min-width: 85%;
    flex: 0 0 85%;
    scroll-snap-align: center;
    margin-bottom: 0;
  }
`;

export default MoreProjects;
